// extracted by mini-css-extract-plugin
export default {"container":"Targets_container__7AUwo","targetContainer":"Targets_targetContainer__x0I31","icon":"Targets_icon__iPsl0"};